import { method } from "@/utils/request"

const url = process.env.VUE_APP_API_URL

export function getSystemConfig() {
  return method(url)({
    url: "system-config",
    method: "get",
    data: {}
  })
}

export function updateSystemConfig(data) {
  return method(url)({
    url: "system-config",
    method: "put",
    data
  })
}

export function backupNow() {
  return method(url)({
    url: "system-config/backup-now",
    method: "post",
    data: {},
    timeout: 1800000
  })
}
